<template>
  <div
    class="container min-body-height"
    :class="UI.isMobile ? '' : 'padding-top'"
  >
    <div class="flex align-center"><h3>赛事详情</h3></div>
    <div class="full-width margin-bottom bg-grey" style="height: 1px;"></div>
    <div class="padding bg-white">
      <el-descriptions
        :title="gameInfo.title"
        :column="1"
        v-if="gameInfo.title"
      >
        <el-descriptions-item label="主办单位">
          {{ gameInfo.org }}
        </el-descriptions-item>
        <el-descriptions-item label="报名时间">
          {{ gameInfo.sign_start_time }} -> {{ gameInfo.sign_end_time }}
        </el-descriptions-item>
        <el-descriptions-item label="比赛日期">
          {{ gameInfo.game_start_time }} -> {{ gameInfo.game_end_time }}
        </el-descriptions-item>
        <el-descriptions-item label="比赛地点">
          {{ gameInfo.address }}
        </el-descriptions-item>
        <el-descriptions-item label="比赛项目" v-if="!isJudgeGame">
          {{
            gameInfo.items
              .map((item) => {
                return item.title;
              })
              .join('/')
          }}
        </el-descriptions-item>
        <el-descriptions-item label="比赛组别" v-if="!isJudgeGame">
          {{ gameInfo.groups ? gameInfo.groups.join('/') : '' }}
        </el-descriptions-item>
      </el-descriptions>
    </div>

    <div
      class="flex margin-top-lg align-center margin-bottom-lg"
      :class="
        UI.isMobile
          ? 'flex-direction justify-center'
          : isJudgeGame
          ? 'justify-start'
          : 'justify-between'
      "
    >
      <div>
        <el-button
          style="background-color: #003366; color: aliceblue"
          @click="toView('news')"
        >
          竞赛规程
        </el-button>
      </div>
      <div :class="isJudgeGame && !UI.isMobile ? 'margin-left-sm' : ''">
        <el-button
          style="background-color: #003366; color: aliceblue"
          @click="getPlayerList()"
          :style="
            $getStateLabel(gameInfo) != $stateConsts.SIGN_STARTED.label
              ? 'color: #C0C4CC'
              : ''
          "
          :disabled="
            $getStateLabel(gameInfo) != $stateConsts.SIGN_STARTED.label
          "
        >
          {{
            $getStateLabel(gameInfo) == $stateConsts.SIGN_STARTED.label
              ? isJudgeGame
                ? '报名'
                : '参赛报名'
              : $getStateLabel(gameInfo) == $stateConsts.PENDING.label
              ? '报名未开始'
              : '报名结束'
          }}
        </el-button>
      </div>
      <div v-if="!isJudgeGame">
        <el-button
          :style="!gameInfo.outs_url ? 'color: #C0C4CC' : ''"
          style="background-color: #003366; color: aliceblue"
          @click="toUrl(gameInfo.outs_url)"
          :disabled="!gameInfo.outs_url"
        >
          实时赛况
        </el-button>
      </div>
      <div v-if="!isJudgeGame">
        <el-button
          :style="!gameInfo.picture_url ? 'color: #C0C4CC' : ''"
          style="background-color: #003366; color: aliceblue"
          @click="toUrl(gameInfo.picture_url)"
          :disabled="!gameInfo.picture_url"
        >
          相册视频
        </el-button>
      </div>
      <div v-if="!isJudgeGame">
        <el-button
          style="background-color: #003366; color: aliceblue"
          @click="toView('results')"
        >
          比赛成绩
        </el-button>
      </div>
    </div>

    <el-dialog
      show-close
      :title="gameInfo.title + ' 报名'"
      v-if="enrollShow"
      :visible.sync="enrollShow"
    >
      <div class="flex flex-direction align-center full-form" v-if="submitShow">
        <el-form
          ref="enrollForm"
          :model="enrollInfo"
          :rules="enrollInfoRules"
          :label-position="UI.isMobile ? 'top' : 'left'"
          :label-width="UI.isMobile ? undefined : '120px'"
          style="width: 90%;"
        >
          <el-form-item label="选择项目" prop="items" v-if="!isJudgeGame">
            <el-select
              placeholder="请选择"
              clearable
              filterable
              multiple
              v-model="enrollInfo.items"
            >
              <el-option
                v-for="item in itemOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item
            :label="isJudgeGame ? '选择岗位' : '选择分组'"
            prop="group"
          >
            <el-select
              :placeholder="isJudgeGame ? '请选择岗位' : '请选择'"
              clearable
              filterable
              v-model="enrollInfo.group"
            >
              <el-option
                v-for="item in groupOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="选择运动员" prop="players" v-if="!isJudgeGame">
            <el-select
              placeholder="请输入姓名"
              clearable
              filterable
              multiple
              v-model="enrollInfo.players"
            >
              <el-option
                v-for="item in playerOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="上传附件" prop="attach">
            <MediaUpload
              ref="attach"
              :action="uploadUrl + '/upload/enroll_attach'"
              :suffixList="['.png', '.jpg', '.pdf']"
              :file="enrollInfo.attach"
              @success="handlerUploadSuccess('attach')"
            ></MediaUpload>
          </el-form-item>
        </el-form>

        <el-button
          class="login-button padding-xs margin-top margin-bottom"
          type="primary"
          size="mini"
          @click="getPlayerInfo()"
        >
          下一步
        </el-button>
      </div>
      <div class="flex flex-direction align-center full-form" v-else>
        <el-table
          :data="submitPlayerList"
          title="名单信息"
          style="width: 100%; margin-bottom: 10px;"
        >
          <el-table-column type="expand">
            <template slot-scope="props">
              <div class="flex justify-center align-center">
                <img :src="props.row.avatar" style="width: 200px;" />
              </div>
              <el-descriptions
                :column="UI.isMobile ? 1 : 3"
                border
                class="margin-top-sm"
              >
                <el-descriptions-item label="性别">
                  {{ props.row.sex == 0 ? '男' : '女' }}
                </el-descriptions-item>

                <el-descriptions-item label="民族">
                  {{ props.row.nation }}
                </el-descriptions-item>

                <el-descriptions-item label="籍贯">
                  {{
                    props.row.native_place ? props.row.native_place.join() : ''
                  }}
                </el-descriptions-item>

                <el-descriptions-item label="手机">
                  {{ props.row.mobile }}
                </el-descriptions-item>

                <el-descriptions-item label="邮箱">
                  {{ props.row.email }}
                </el-descriptions-item>

                <el-descriptions-item label="出生日期">
                  {{ props.row.identifier_code ? props.row.birthday : '' }}
                </el-descriptions-item>

                <el-descriptions-item label="通讯地址">
                  {{ props.row.address }}
                </el-descriptions-item>

                <el-descriptions-item label="比赛项目" v-if="!isJudgeGame">
                  <div class="text-bold">
                    {{
                      enrollInfo.items
                        .map((item) => {
                          return itemsMap[item];
                        })
                        .join('/')
                    }}
                  </div>
                </el-descriptions-item>

                <el-descriptions-item
                  :label="isJudgeGame ? '岗位' : '比赛组别'"
                >
                  <div class="text-bold">{{ enrollInfo.group }}</div>
                </el-descriptions-item>
              </el-descriptions>
            </template>
          </el-table-column>
          <el-table-column label="姓名" prop="name"></el-table-column>
          <el-table-column
            label="证件号码"
            prop="identifier_code"
          ></el-table-column>
        </el-table>
        <div class="flex justify-center align-center margin-bottom-sm">
          <el-button
            class="login-button padding-xs margin-top"
            type="info"
            size="mini"
            @click="submitShow = true"
          >
            返回
          </el-button>
          <el-button
            class="login-button padding-xs margin-top"
            type="primary"
            size="mini"
            @click="submit()"
          >
            报名
          </el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getGameById, doEnroll, getSubmitPlayerInfo } from '@/servers/games.js';
import { getOwnerPlayers } from '@/servers/players.js';
import { showSuccessMsg, showErrorMsg } from '@/utils/uiUtils.js';
import { mapState } from 'vuex';
import MediaUpload from '@/components/upload/mediaUpload.vue';
import { baseUrl } from '@/utils/consts.js';

import { wxShareMixins } from '@/mixins/wx_share.js';

export default {
  mixins: [wxShareMixins],
  components: {
    MediaUpload,
  },

  data() {
    return {
      uploadUrl: baseUrl,
      shareDesc: '',
      shareTitle: '',
      gameInfo: {},
      enrollInfo: {},
      enrollShow: false,
      submitShow: true,
      playerOptions: [],
      submitPlayerList: [],
      itemOptions: [],
      itemsMap: {},
      groupOptions: [],
      enrollInfoRules: {
        items: [
          {
            required: true,
            message: '请选择',
            trigger: 'blur',
          },
        ],
        group: [
          {
            required: true,
            message: '请选择',
            trigger: 'blur',
          },
        ],
        players: [
          {
            required: true,
            message: '请选择',
            trigger: 'blur',
          },
        ],
      },
    };
  },

  computed: {
    ...mapState(['UI', 'User']),

    isJudgeGame: function() {
      return !!this.gameInfo.is_judge_game;
    },
  },

  watch: {
    $route: 'routeChange',
  },

  created() {
    this.routeChange();
  },

  methods: {
    handlerUploadSuccess: function(key) {
      this.enrollInfo[key] = this.$refs[key].uploadRes;
    },

    getPlayerList: function() {
      let that = this;
      if (this.isJudgeGame) {
        this.judgeEnroll();
        return;
      }
      getOwnerPlayers({}, function(res) {
        that.playerOptions = [];
        res.forEach((item) => {
          that.playerOptions.push({
            label: `${item.name}[${item.sex == 0 ? '男' : '女'}][${
              item.birthday ? item.birthday.substring(0, 4) : ''
            }]`,
            value: item.id,
          });
        });
        if (!that.playerOptions.length) {
          showErrorMsg('没有可报名的运动员，需信息审核通过');
          return;
        }
        that.enrollInfo = {};
        that.submitShow = true;
        that.enrollShow = true;
      });
    },

    judgeEnroll: function() {
      if (!this.User.hasLogin) {
        showErrorMsg('请先登录后再报名');
        this.$router.push({
          name: 'login',
        });
        return;
      }
      if (!this.User.user || !this.User.user_info || !this.User.user_info.id) {
        showErrorMsg('用户信息加载中，请稍后重试');
        return;
      }
      if (this.User.user.role != this.$roleConsts.TECH_OFFICER.value) {
        showErrorMsg('该赛事仅限技术官员报名');
        return;
      }
      if (this.User.user_info.is_approved != this.$approveConsts.APPROVED.value) {
        showErrorMsg('您的信息未通过审核，无法报名');
        return;
      }
      if (!this.itemOptions.length || !this.groupOptions.length) {
        showErrorMsg('赛事项目配置有误，请联系管理员');
        return;
      }
      this.enrollInfo = {
        items: [this.itemOptions[0].value],
        group: '',
        players: [this.User.user_info.id],
      };
      this.submitShow = true;
      this.enrollShow = true;
    },

    routeChange: function() {
      let that = this;
      getGameById(this.$route.query.id, {}, function(res) {
        that.gameInfo = res;
        that.shareTitle = res.title;
        that.shareDesc = `比赛日期:${that.gameInfo.game_start_time} -> ${that.gameInfo.game_end_time}; 比赛地点: ${that.gameInfo.address}`;
        that.itemOptions = [];
        that.groupOptions = [];
        that.itemsMap = {};

        res.items.forEach((item) => {
          that.itemOptions.push({
            label: item.title,
            value: item.id,
          });
          that.itemsMap[item.id] = item.title;
        });

        res.groups.forEach((item) => {
          that.groupOptions.push({
            label: item,
            value: item,
          });
        });
      });
    },

    toView: function(index) {
      this.$router.push({
        name: index,
        query: { id: this.$route.query.id, cate: 'games' },
      });

      // const url = this.$router.resolve({
      //   name: index,
      //   query: { id: this.$route.query.id, cate: 'games' },
      // });
      // window.open(url.href, '_blank');
    },

    toUrl: function(url) {
      window.open(url, '_blank');
    },

    getPlayerInfo: function() {
      let that = this;
      this.$refs.enrollForm.validate((valid) => {
        if (valid) {
          getSubmitPlayerInfo(this.enrollInfo, function(res) {
            that.submitPlayerList = res;
            that.submitShow = false;
          });
        }
      });
    },

    submit: function() {
      let that = this;
      doEnroll(this.$route.query.id, this.enrollInfo, function(res) {
        that.enrollInfo = {};
        that.enrollShow = false;
        showSuccessMsg(res);
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/index/games/info.vue